import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const disconnectP2PStackThunk = createAppAsyncThunk<
  { sixId: string },
  { sixId: string }
>(
  'connection/disconnectP2PStack',
  async({ sixId }, { extra: { pocServices }, rejectWithValue }) => {
    try {
      await pocServices.p2pStackManagerService.shutdownStack(sixId);
      return { sixId };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return rejectWithValue({ message });
    }
  }
);
